/**
 * Admin invite / partner management collection names
 */

export const SALES_PARTNER_INVITES_COLLECTION = 'sales_partner_invites';
export const WEBSITE_OWNER_INVITES_COLLECTION = 'website_owner_invites';
export const SALES_PARTNERS_COLLECTION = 'sales_partners';
export const WEBSITE_OWNERS_COLLECTION = 'website_owners';
export const REFERRAL_CODES_COLLECTION = 'referral_codes';
export const USERS_COLLECTION = 'users';
